import React from 'react';
import { Spinner } from '@isyc-react/design/bootstrap';
export const LookAndFeelUnloggedLoading = () => {
    return (React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
        React.createElement(Spinner, { animation: 'border' })));
};
export const LookAndFeelUnloggedError = props => {
    const { error } = props;
    return React.createElement(React.Fragment, null, error === 'query' ? React.createElement(React.Fragment, null, "Error getting BU look and feel") : React.createElement(React.Fragment, null, "Error parsing BU look and feel theme"));
};
